import { Progress } from '@mantine/core';
import { coral } from 'theme/colors';

// ==============================|| LOADER ||============================== //
const Loader = () => (
  <div
    style={{
      position: 'fixed',
      top: 0,
      left: 0,
      zIndex: 1301,
      width: '100%'
    }}
  >
    <Progress value={100} color={coral[6]} size="xs" animated />
  </div>
);

export default Loader;
